import {
  canUnsubscribe,
  deriveSubscriptionState,
} from "@components/PayRangeSubscriptionCard/payRangeSubscriptionCardUtils";
import { formatFairPayDate, formatFairPayVersion } from "@components/utils/fairPayFormat";
import { formatVersionBarAmount } from "@components/PayRangeVersionBar/payRangeVersionBarUtils";

const EN_DASH = "\u2013";
const MIDDLE_DOT = "\u00B7";

export function formatHistoryWindow(start, end) {
  const from = formatFairPayDate(start);
  if (!from) return "";
  const to = formatFairPayDate(end);
  return to ? `${from} ${EN_DASH} ${to}` : `${from} ${EN_DASH} present`;
}

export function formatHistoryPayBand(amountMin, amountMax) {
  const min = formatVersionBarAmount(amountMin);
  const max = formatVersionBarAmount(amountMax);
  if (min && max) return `${min}${EN_DASH}${max}`;
  return min || max || "";
}

export function formatHistoryTitle(subscriptionCode, positionTitle) {
  const code = String(subscriptionCode || "").trim();
  const title = String(positionTitle || "").trim();
  if (code && title) return `${code} ${MIDDLE_DOT} ${title}`;
  return code || title;
}

export function formatHistoryVersionLabel(ordinal, start, end) {
  const version = formatFairPayVersion(ordinal);
  const window = formatHistoryWindow(start, end);
  return window ? `${version} ${MIDDLE_DOT} ${window}` : version;
}

export function formatHistoryGapLabel(from, to) {
  const window = formatHistoryWindow(from, to);
  return window ? `gap ${MIDDLE_DOT} ${window}` : "gap";
}

export function versionOrdinalValue(ordinal) {
  const n = Number(String(ordinal ?? "").replace(/^v/i, ""));
  return Number.isFinite(n) ? n : 0;
}

export function mapHistoryVersion(version = {}, today) {
  const window = version.effectiveWindow || {};
  return {
    key: `${version.ordinal ?? ""}-${window.start ?? ""}-${window.end ?? ""}`,
    ordinal: version.ordinal,
    state: deriveSubscriptionState(window.start, window.end, today),
    label: formatHistoryVersionLabel(version.ordinal, window.start, window.end),
    payBand: formatHistoryPayBand(version.payBandMin, version.payBandMax),
    kind: "version",
  };
}

export function mapHistoryGap(gap = {}) {
  return {
    key: `gap-${gap.from ?? ""}-${gap.to ?? "open"}`,
    label: formatHistoryGapLabel(gap.from, gap.to),
    payBand: "",
    kind: "gap",
  };
}

export { canUnsubscribe, deriveSubscriptionState };
